module.exports = __webpack_public_path__ + "static/media/tra_sta_pla.f11157e2.png";